export default (t) => [
  {
    text: t('Message'),
    value: 'message',
    sortable: false,
    fixed: false,
    width: 500
  },
  {
    text: t('Created At'),
    value: 'created_at',
    sortable: true,
    width: 250
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false
  }
];
